export default "__VITE_ASSET__a1beebda__"